
import { GetDeliveryNumbersResponseModel } from "@dana/Types/ApiModels";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

// Define the state type for this fetch workflow
export interface DanaDeliveryNumbersState {
    isLoading: boolean,    
    data: GetDeliveryNumbersResponseModel | null,    // Use a more specific type if known
    error: string | null,
}

const initialDeliveryNumbersState: DanaDeliveryNumbersState = {
    isLoading: false,   
    data: null,
    error: null
};

// Create Immer reducer
const danaDeliveryNumbersReducer = createTypedReducerWithImmer(initialDeliveryNumbersState, {
    // Start loading
    "OrdersDelivery/IsLoading": (draft, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
        if (action.isLoading) {
            draft.error = null; // Optionally reset error if reloading
        }
    },

    // Populate result on success
    "OrdersDelivery/PopulateResult": (draft, action: { data: any }) => {        
        draft.data = action.data;       
        draft.isLoading = false;
        draft.error = null;
    },

    // Handle error
    "OrdersDelivery/FetchError": (draft, action: { error: string }) => {
        draft.error = action.error;
        draft.isLoading = false;
    },

    // Reset all state (optional)
    "OrdersDelivery/Reset": draft => {
        draft.isLoading = false;
        draft.data = null;
        draft.error = null;
    }
});

// Register reducer in the root
(reducers as any).danaDeliveryNumbers = danaDeliveryNumbersReducer;

// Define type for action usage
type DanaDeliveryNumbersReducers = {
    danaDeliveryNumbers: typeof danaDeliveryNumbersReducer;
};

export type DanaDeliveryNumbersActions = Parameters<DanaDeliveryNumbersReducers[keyof DanaDeliveryNumbersReducers]>[1] | AnyAction;
